// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"
import Rails from "@rails/ujs";
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element,{
      group:{
        name: 'shared',
      },
      handle:".drag-menu",
      animation: 150,
      onEnd: this.end.bind(this)
    })
  }
  remove(data){
    let menuID = data.target.dataset.menu
    let menuRecipeID = data.target.dataset.menuRecipe
    let uniqueRecipeID = data.target.dataset.uniqueid
    let elementRecipe = document.getElementById(menuRecipeID)
    const element = document.getElementById("ajax_delete");
    console.log("removeee")
    Rails.ajax({
      url: `/menus/${menuID}/remove_recipe_menu/${uniqueRecipeID}`,
      type: 'GET',
      success: function(response){
        const parentElement = data.target.closest(".card-edit-menu")
        parentElement.parentNode.removeChild(parentElement);
        element.classList.remove("d-none")
        setTimeout(function() {
          element.classList.add("d-none")
        }, 2000);
      },
      error: function(err){
        element.classList.remove("d-none")
        setTimeout(function() {
          element.classList.add("d-none")
        }, 2000);
      }
    })    
  }

  addrecipe(data){
    let menuID = data.target.dataset.calendar
    let recipeMenuID = data.target.dataset.uniqueid
    console.log("click add")
    Rails.ajax({
      url: `/menus/${menuID}/addRecipeMenu/${recipeMenuID}`,
      type: 'POST',
      success: function(response){
      },
      error: function(err){
        const element = document.getElementById("ajax_error");
        element.classList.remove("d-none")
        setTimeout(function() {
          element.classList.add("d-none")
        }, 2000);
      }
    })
  }

  end(e){
    let menuID = e.to.dataset.menu
    let recipeMenuID = e.item.dataset.menurecipeid // ID Receta
    // let uniqueRecipeID = data.target.dataset.uniqueid
    let data = new FormData()

    Rails.ajax({
      url: `/menus/${menuID}/recipe_menu_update/${recipeMenuID}`,
      type: 'PATCH',
      data:data,
      success: function(response){
        console.log("holaa")
        const element = document.getElementById("ajax_success");
        element.classList.remove("d-none")
        setTimeout(function() {
          element.classList.add("d-none")
        }, 2000);
      },
      error: function(err){
        const element = document.getElementById("ajax_error");
        element.classList.remove("d-none")
        setTimeout(function() {
          element.classList.add("d-none")
        }, 2000);
      }
    })
  }
}
